import { Bell, HelpCircle, Menu } from "lucide-react";
import { Link } from "react-router-dom";

export default function Topbar({ onMenuClick }) {
  return (
    <header className="h-20 bg-white border-b border-slate-200 px-4 md:px-6 flex items-center justify-between sticky top-0 z-30">
      {/* Left Side */}
      <button
        onClick={onMenuClick}
        className="lg:hidden h-10 w-10 rounded-xl border border-slate-200 flex items-center justify-center hover:bg-slate-100 transition"
      >
        <Menu size={20} />
      </button>
      <div></div>

      {/* Right Side */}
      <div className="flex items-center gap-4">
        {/* Search */}
        {/* <div className="relative hidden xl:block">
          <Search
            size={18}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
          />

          <input
            type="text"
            placeholder="Search..."
            className="
              w-[260px]
              pl-10
              pr-4
              py-2.5
              rounded-xl
              border
              border-slate-200
              bg-slate-50
              focus:outline-none
              focus:ring-2
              focus:ring-indigo-500
            "
          />
        </div> */}

        {/* Trial Banner */}
        <div className="hidden lg:flex items-center gap-3 bg-amber-50 border border-amber-200 text-amber-800 px-4 py-2 rounded-xl">
          <span className="text-sm font-medium">Trial ends in 4 days</span>

          <button className="bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium px-4 py-2 rounded-lg transition">
            Upgrade Now
          </button>
        </div>

        {/* Help */}
        <Link
          to="/help"
          className="h-10 w-10 rounded-xl border border-slate-200 flex items-center justify-center hover:bg-slate-100 transition"
        >
          <HelpCircle size={18} />
        </Link>

        {/* Notifications */}
        <button className="relative h-10 w-10 rounded-xl border border-slate-200 flex items-center justify-center hover:bg-slate-100 transition">
          <Bell size={18} />

          <span className="absolute top-2 right-2 h-2 w-2 bg-red-500 rounded-full" />
        </button>
      </div>
    </header>
  );
}
